import AccordionButton from '@/components/accordion-button';
import NoneChip from '@/components/chip/none-chip';
import StatusChip from '@/components/chip/status-chip';
import Text from '@/components/text';
import { getNiceDate } from '@/lib/helpers';
import {
  TelemetrySources,
  TelemetrySourceUserEvent,
} from '@/lib/models/telemetry/telemetry-sources';
import { TelemetryModel } from '@/lib/models/telemetry/telemetry.model';
import { Stack } from '@mui/material';
import { FC } from 'react';

interface Props {
  sourceType: keyof TelemetrySources;
  telemetry: TelemetryModel;
}

const TelemetrySourceCard: FC<Props> = ({ telemetry, sourceType }) => {
  const { enabled, schemaVersion, includeConversationData } = telemetry.telemetryTypes[
    sourceType
  ] as TelemetrySourceUserEvent;
  const { lastSyncedAt } = telemetry.syncState[sourceType];
  const isUserEvent = sourceType === 'userEvents';

  const TitleEl = (
    <Stack direction="row" gap={1} justifyContent="space-between" width="100%">
      <Text bold size="small">
        {isUserEvent ? 'User Events' : 'Audit Events'}
      </Text>
      <StatusChip value={enabled} size="x-small" />
    </Stack>
  );

  return (
    <AccordionButton title={TitleEl}>
      <Stack gap={2}>
        <Stack direction="row" justifyContent="space-between">
          <Text size="small">Schema Version</Text>
          <Text size="small">{schemaVersion || <NoneChip notAvailable />}</Text>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Text size="small">Last Synced Date</Text>
          <Text size="small">
            {lastSyncedAt ? getNiceDate(lastSyncedAt).formatted : <NoneChip notAvailable />}
          </Text>
        </Stack>
        {isUserEvent && (
          <Stack direction="row" justifyContent="space-between">
            <Text size="small">Include Conversation Data</Text>
            <StatusChip value={!!includeConversationData} size="x-small" />
          </Stack>
        )}
      </Stack>
    </AccordionButton>
  );
};

export default TelemetrySourceCard;
